export default "__VITE_ASSET__37cf9c74__"